import { lazy, createElement, Suspense } from 'react';
import {
  createPlugin,
  createRoutableExtension,
  createApiFactory,
  discoveryApiRef,
  fetchApiRef,
} from '@backstage/core-plugin-api';

import { rootRouteRef } from './routes';
import { geminiAgentApiRef, GeminiAgentClient } from './api';

export const geminiAgentPlugin = createPlugin({
  id: 'gemini-agent',
  routes: {
    root: rootRouteRef,
  },
  apis: [
    createApiFactory({
      api: geminiAgentApiRef,
      deps: {
        discoveryApi: discoveryApiRef,
        fetchApi: fetchApiRef,
      },
      factory: ({ discoveryApi, fetchApi }) =>
        new GeminiAgentClient(discoveryApi, fetchApi),
    }),
  ],
});

export const GeminiAgentPageExtension = geminiAgentPlugin.provide(
  createRoutableExtension({
    name: 'GeminiAgentPage',
    component: () =>
      import('./components/GeminiAgentPage').then(m => m.GeminiAgentPage),
    mountPoint: rootRouteRef,
  }),
);

export const GeminiAgentPage = () => {
  const LazyComponent = lazy(() =>
    import('./components/GeminiAgentPage').then(module => ({
      default: module.GeminiAgentPage,
    })),
  );

  return createElement(
    Suspense,
    {
      fallback: createElement('div', {}, 'Loading Gemini Agent...'),
    },
    createElement(LazyComponent),
  );
};
